/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { useQuery } from '@apollo/client';
import mbpLogger from '@module-logger/mbp';
import {
    string, shape, number, object, func, bool, arrayOf,
} from 'prop-types';
import { GRAPHQL_ENV } from '../../../../../gql';
import { getProductDetailBySKU } from '../../../../../pages/Account/services/graphQL';
import FoodRadioLabel from './FoodRadioLabel';
import { productType, selectedSkuType } from '../common/types';

/*
    Purpose of the component is to fetch the availablity message for upsells
    This is only acting as a layer and can be replaced easily with FoodRadioLabel
*/

const FoodRadioLabelContainer = ({
    classes,
    product,
    isPassportBundleProduct,
    productSku,
    location,
    productUrl,
    brand,
    selectedSku,
    isPdpYotpoEnabled,
    renderSkuPrice,
    pricesList,
    skuType,
    isCyoProduct,
    isPdpRedesignEnabled,
}) => {
    const domain = brand ? brand?.domain : null;
    const FIND_PDP_BY_PART = getProductDetailBySKU(productSku.id, domain, GRAPHQL_ENV);

    const isUpsell = skuType === 'Upsell';
    const { data, error } = useQuery(FIND_PDP_BY_PART, {
        skip: !isUpsell,
    });

    if (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            query: FIND_PDP_BY_PART,
            component: 'FoodRadioLabelContainer.js',
            message: 'Error loading data from Graphql',
            env: GRAPHQL_ENV,
            error,
        });
    }

    return (
        <>
            <FoodRadioLabel
                classes={classes}
                product={product}
                isPassportBundleProduct={isPassportBundleProduct}
                productSku={data?.findProductByPartNumber || productSku}
                skuType={skuType}
                location={location}
                productUrl={productUrl}
                brand={brand}
                selectedSku={selectedSku}
                isPdpYotpoEnabled={isPdpYotpoEnabled}
                renderSkuPrice={renderSkuPrice}
                pricesList={pricesList}
                isCyoProduct={isCyoProduct}
                isPdpRedesignEnabled={isPdpRedesignEnabled}
            />
        </>
    );
};

FoodRadioLabelContainer.propTypes = {
    classes: object.isRequired,
    skuType: string.isRequired,
    brand: shape({
        domain: string,
    }).isRequired,
    selectedSku: selectedSkuType.isRequired,
    product: productType.isRequired,
    productUrl: string.isRequired,
    location: shape({
        state: shape({
            categoryId: string,
            categoryName: string,
        }),
    }).isRequired,
    renderSkuPrice: func.isRequired,
    isPassportBundleProduct: shape({
        prices: {
            value: number,
        },
        enable: bool,
    }),
    productSku: selectedSkuType.isRequired,
    isPdpYotpoEnabled: bool,
    pricesList: arrayOf(shape({
        value: number,
        type: string,
    })),
    isCyoProduct: bool,
    isPdpRedesignEnabled: bool,
};

FoodRadioLabelContainer.defaultProps = {
    isPassportBundleProduct: {},
    isPdpYotpoEnabled: false,
    pricesList: null,
    isCyoProduct: false,
    isPdpRedesignEnabled: false,
};

export default FoodRadioLabelContainer;
